import { createFileRoute, Link, Outlet, useMatches } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { adminCmsPagesQuery } from "@/lib/cms/queries";
import { PageHeader, StatusPill } from "@/components/admin/PageHeader";

export const Route = createFileRoute("/admin/cms")({ component: CmsLayout });

function CmsLayout() {
  const matches = useMatches();
  const hasChild = matches.some((m) => m.routeId === "/admin/cms/$slug");
  if (hasChild) return <Outlet />;
  return <CmsIndex />;
}

function CmsIndex() {
  const pages = useQuery(adminCmsPagesQuery()).data ?? [];
  return (
    <div className="flex flex-col gap-5">
      <PageHeader title="CMS pages" subtitle={`${pages.length} pages | block-based editor`} />
      <div className="overflow-x-auto border border-black/10 bg-white">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="border-b border-black/10 text-left text-[10px] font-semibold uppercase tracking-[0.2em] text-black/50">
              <th className="px-3 py-2">Page</th>
              <th className="px-3 py-2">Slug</th>
              <th className="px-3 py-2">Status</th>
              <th className="px-3 py-2">Updated</th>
              <th className="px-3 py-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {pages.map((p) => (
              <tr key={p.slug} className="border-b border-black/5">
                <td className="px-3 py-2 font-medium text-black">{p.title} {p.isSystem && <span className="ml-1 text-[10px] uppercase tracking-widest text-black/40">system</span>}</td>
                <td className="px-3 py-2 font-mono text-[12px] text-black/60">{p.slug}</td>
                <td className="px-3 py-2">{p.status === "published" ? <StatusPill tone="success">Published</StatusPill> : <StatusPill tone="warn">Draft</StatusPill>}</td>
                <td className="px-3 py-2 text-black/70">{new Date(p.updatedAt).toLocaleString()}</td>
                <td className="px-3 py-2 text-right">
                  <Link to="/admin/cms/$slug" params={{ slug: p.slug }} className="border border-black/15 px-2 py-1 text-[11px] hover:border-black/50">Edit</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
